import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingLayout = () => {
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <Spin indicator={<LoadingOutlined />} />
    </div>
  );
};

export default LoadingLayout;
